let resMonitorPath = '';
if (process.env.VUE_APP_DEV_TYPE === 'serve') {
  resMonitorPath = '/resource_monitor_path';
}

export default {
  applicationList: resMonitorPath + '/api/zdCicd/application/list/condition', // 获取应用列表
  query_range: resMonitorPath + '/api/monitor/api/v1/query_range', // 查询范围
  query: resMonitorPath + '/api/monitor/api/v1/query', // 查询
};
